import styled from 'styled-components'

export const Container = styled.div`
    border-radius: 5px;
    min-width: 325px;
    display:flex;
    flex-direction: column;
    background-color: transparent;
    height: ${props =>(props.$IsDetail? 'auto': '100%')};
    max-height: ${props =>(props.$IsDetail? 'auto': '100%')};
    gap: 5px;
    width: 85%;
    @media (min-width: 720px) {
        width:25%;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        min-width: 280px;
    }
`;

export const Title = styled.h3`
    color: #333;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 42px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    width: 80%;
    max-height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const InputTitle = styled.input`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    color: #333;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    width: 80%;
    outline: none;
    border: 1px solid #006560;
    border-radius: 15px;
    ${({ readOnly }) => readOnly ? 'readonly: false' : 'readonly: true'};
    ${({ readOnly }) => readOnly ? 'border: none' : 'border: 1px solid #006560'};
    @media (min-width: 1281px) {
        font-size: 24px;
    }
`;

export const EditButton = styled.button`
    display: flex;
    background: transparent;
    padding: 5px;
    cursor: pointer;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const TrashButton = styled.button`
    display: flex;
    background: transparent;
    padding: 5px;
    cursor: pointer;
    border-radius: 10px;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    &:hover {
        background: #FF3939;
        color: #fff;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 14px;
    gap: 5px;
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    @media (min-width: 1281px) {
        padding: 19px;
    }
`;

export const ItensList = styled.div`
    background-color: ${props => (props.$isDraggingOver ? '#d5f3ff' : 'transparent')};
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    min-height: 50px;
    overflow: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
        width : 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ContainerItem = styled.div`
    margin-bottom:8px;
    border-radius:2px;
    background-color:${props => (props.$isDragging ? '#e0ffe0' : 'transparent')};
    border-radius: 15px;
`
